"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _constanst = require("../../../utils/constanst");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Textarea = function Textarea(_ref) {
  var field = _ref.field,
      handleChangeInput = _ref.handleChangeInput;

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      err = _useState2[0],
      setErr = _useState2[1];

  (0, _react.useEffect)(function () {
    if (field.hasError) {
      setErr(_constanst.MSG_REQUIRED);
    }
  }, [field.hasError]);

  var newIsValid = function newIsValid(field, value) {
    var validation = new RegExp(field.customValidation, "i");
    var result = validation.test(value);
    return result;
  };

  console.log("ESTILOS textarea field: ", field);
  var defaultStyles = {};
  var style = !field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(field.customStyles);
  console.log("ESTILOS textarea style: ", style);
  return /*#__PURE__*/React.createElement(_TextField.default, {
    onChange: function onChange(e) {
      handleChangeInput(field.uid, e.target.value);

      if (!field.allowNull && e.target.value === "") {
        setErr(field.customRequiredMessage ? field.customRequiredMessage : _constanst.MSG_REQUIRED);
      } else if (field.customValidation) {
        if (!newIsValid(field, e.target.value)) {
          setErr(field.customValidationMessage ? field.customValidationMessage : _constanst.MSG_REQUIRED);
        } else {
          setErr("");
        }
      } else {
        setErr("");
      }
    },
    value: field.value,
    multiline: true,
    rows: 4,
    label: field.label,
    style: style,
    placeholder: field.placeholder,
    helperText: err,
    error: err === "" ? false : true,
    inputProps: {
      maxLength: field.maxLength
    }
  });
};

var _default = Textarea;
exports.default = _default;